<template>
      <!-- Primary Event Banner  -->
      <div style="position: relative; z-index: 1000;">
      <v-row  v-if="showBanner && nextEvent" class="event-banner pa-0" align="center" justify="center">
        <!-- Title for all screen sizes, hidden on xs -->
        <!-- <v-col cols="12" class="d-none d-sm-flex justify-content-center mt-2">
          <p class="text-h5 event-title">{{ nextEvent?.eventTitle }}</p>
        </v-col> -->
  
        <!-- Expandable section for xs screens -->
        <v-col cols="12" class="d-sm-none" style="padding-bottom: 0px;">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <p class="text-h5 event-title mb-0">{{ nextEvent.eventTitle }}</p>
                <!-- <v-icon>mdi-chevron-down</v-icon> -->

              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align="center" justify="center">
                  <v-col cols="6" sm="3" md="2" order="1" order-sm="1" class="d-flex justify-content-center align-items-center mb-2">
                    <div class="event-timer d-flex ml-5">
                      <template v-if="timeRemaining > 86400000">
                        <!-- Show days and hours if more than 24 hours remaining -->
                        <div class="time-box">
                          <span class="time-value">{{ displayDays }}</span>
                          <span class="time-label">DAYS</span>
                        </div>
                        <div class="colon-box">
                          <span class="colon">:</span>
                        </div>
                        <div class="time-box">
                          <span class="time-value">{{ displayHours }}</span>
                          <span class="time-label">HRS</span>
                        </div>
                      </template>
                      <template v-else-if="timeRemaining > 600000">
                        <!-- Show only hours and minutes if less than 24 hours but more than 10 minutes remaining -->
                        <div class="time-box">
                          <span class="time-value">{{ displayHours }}</span>
                          <span class="time-label">HRS</span>
                        </div>
                        <div class="colon-box">
                          <span class="colon">:</span>
                        </div>
                        <div class="time-box">
                          <span class="time-value">{{ displayMinutes }}</span>
                          <span class="time-label">MINS</span>
                        </div>
                      </template>
                      <template v-else>
                        <!-- Show only minutes and seconds when 10 minutes or less remaining -->
                        <div class="time-box">
                          <span class="time-value">{{ displayMinutes }}</span>
                          <span class="time-label">MIN</span>
                        </div>
                        <div class="colon-box">
                          <span class="colon">:</span>
                        </div>
                        <div class="time-box">
                          <span class="time-value">{{ displaySeconds }}</span>
                          <span class="time-label">SEC</span>
                        </div>
                      </template>
                    </div>

                  </v-col>
              
                  <v-col cols="12" sm="6" md="8" order-sm="2" class="text-left d-flex justify-content-left align-items-center">
                    <div class="event-info">
                      <p class="event-description" v-html="nextEvent?.description"></p>
                    </div>
                  </v-col>
              
                  <v-col cols="6" sm="3" md="2" order="2" order-sm="3" mb="2" class="d-flex justify-content-left align-items-center mb-2">
                    <v-btn class="btn-register" @click="register">
                      <router-link
                        :to="{
                          name: 'event-detail',
                          query: { id: nextEvent?.id },
                        }"
                        style="color: #FFF;"
                        >Read More 
                      </router-link>
                    </v-btn>
                  </v-col>
                </v-row>
                
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
  
        <!-- Content for sm screens and up -->
        <v-col cols="6" sm="3" md="2" class="pb-0 d-none d-sm-flex justify-content-center align-items-center mt-2 mb-2">
          <div class="event-timer d-flex ml-5">
            <template v-if="timeRemaining > 86400000">
        <!-- Show days and hours if more than 24 hours remaining -->
        <div class="time-box">
          <span class="time-value">{{ displayDays }}</span>
          <span class="time-label">DAYS</span>
        </div>
        <div class="colon-box">
          <span class="colon">:</span>
        </div>
        <div class="time-box">
          <span class="time-value">{{ displayHours }}</span>
          <span class="time-label">HRS</span>
        </div>
      </template>
      <template v-else-if="timeRemaining > 600000">
        <!-- Show only hours and minutes if less than 24 hours but more than 10 minutes remaining -->
        <div class="time-box">
          <span class="time-value">{{ displayHours }}</span>
          <span class="time-label">HRS</span>
        </div>
        <div class="colon-box">
          <span class="colon">:</span>
        </div>
        <div class="time-box">
          <span class="time-value">{{ displayMinutes }}</span>
          <span class="time-label">MINS</span>
        </div>
      </template>
      <template v-else>
        <!-- Show only minutes and seconds when 10 minutes or less remaining -->
        <div class="time-box">
          <span class="time-value">{{ displayMinutes }}</span>
          <span class="time-label">MIN</span>
        </div>
        <div class="colon-box">
          <span class="colon">:</span>
        </div>
        <div class="time-box">
          <span class="time-value">{{ displaySeconds }}</span>
          <span class="time-label">SEC</span>
        </div>
      </template>
      </div>
        </v-col>
        
        <v-col cols="12" sm="6" md="7" class="d-none p-0 d-sm-flex text-left justify-start align-center ">
          <div class="event-info mt-4">
            <p class="event-title" v-html="nextEvent?.eventTitle"></p>
            <p class="event-description mt-2 mb-3 mb-0" v-html="nextEvent.description"></p>
          </div>
        </v-col>
        
        <v-col cols="6" sm="3" md="2" class="d-none d-sm-flex justify-center align-center mt-2">
          <v-btn class="btn-register" @click="register"><router-link
            :to="{
              name: 'event-detail',
              query: { id: nextEvent?.id },
            }"
            style="color: #FFF;"
            >Read More 
          </router-link></v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <pageHeader :showBackgroundImage="false"></pageHeader>
      </v-row>
        
  </div>
  </template>
  
  <script>
  import axios from 'axios';
  import pageHeader from './library/widgets/page-header.vue';
  export default {
    components: {
      pageHeader,
    },
    data() {
      return {
        events: {
          upcoming: { items: [], itemCount: 0 },
        },
        isMobile: false,
        nextEvent: null,
        timeRemaining: 0,
        showBanner: false, // Initially false
        showSecondaryBanner: false, // New property for the secondary banner
      };
    },
    computed: {
      displayDays() {
      // Display days if more than 24 hours remain
      return this.timeRemaining > 86400000
        ? Math.floor(this.timeRemaining / 86400000).toString().padStart(2, '0')
        : '00';
    },
    displayHours() {
      // Display hours differently based on time remaining
      return this.timeRemaining > 86400000
        ? Math.floor((this.timeRemaining % 86400000) / 3600000).toString().padStart(2, '0')
        : this.timeRemaining > 600000
        ? Math.floor(this.timeRemaining / 3600000).toString().padStart(2, '0')
        : '00';
    },
    displayMinutes() {
      // Show only minutes if under 10 minutes, otherwise calculate minutes left in the hour
      return this.timeRemaining > 600000
        ? Math.floor((this.timeRemaining % 3600000) / 60000).toString().padStart(2, '0')
        : Math.floor(this.timeRemaining / 60000).toString().padStart(2, '0');
    },
    displaySeconds() {
      // Show seconds only when the time remaining is 10 minutes or less
      return this.timeRemaining <= 600000
        ? Math.floor((this.timeRemaining % 60000) / 1000).toString().padStart(2, '0')
        : '';
    },
    },
    methods: {
      register() {
        // Implement registration logic here
        console.log("Registering for event:", this.nextEvent.eventTitle);
      }
    },
    mounted() {
      this.getEvents();
      // Refresh events periodically (e.g., every 5 minutes)
      setInterval(this.getEvents, 5 * 60 * 1000);
    }
  }
  </script>
  
  <style scoped>

.event-description {
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.event-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5rem;
    background: #424ec4;
    height: auto;
    max-height: 233px;
}
.event-title {
    color: #FFF;
    font-family: "GeomGraphic";
    font-size: clamp(14px, 2.5vw, 18px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 0rem !important;
    -webkit-display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}

.event-description >>> p {
  margin-bottom: 0 !important;
  color: #FFF;
  font-family: Rajdhani;
  font-size: clamp(12px, 2.5vw, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.event-info {
  flex-grow: 1;
  color: #FFF;
}

.event-timer {
  display: flex;
  gap: 1rem;
  margin: 0 1rem;
}

.time-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000;
  padding: 0.5rem;
  border-radius: 4px;
  border-radius: 5px;
  background: #FFF;
  width: 37%;
  height: 95%;
  flex-shrink: 0;

}
.colon-box {
  display: flex;
  align-items: center;
  color: #fff;
  flex-shrink: 0;

}
.colon {
  font-size: 24px;
  font-weight: 700;
}
.time-value {
    color: #000;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    font-size: clamp(12px, 2.5vw, 24px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-bottom: 4px;
}

.time-label {
    text-transform: uppercase;
    color: #3663B0;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.btn-register {
    border-radius: 50px;
    border: 1px solid #FFF;
    background-color: transparent !important;
    color: #FFF;
    text-align: center;
    cursor: pointer;
    /* M3/label/large */
    font-family: 'GeomGraphic';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
}

:deep .theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #424EC4 !important;
  color: rgba(0, 0, 0, .87);
}
:deep .v-icon__svg {
  color: #fff !important;
}

.readiness-row {
        width: auto;
        height: auto;
        font-family: Rajdhani;
        font-style: normal;
        line-height: normal;
        color: #fff;
        text-align: left;
        padding-left: 20px;
        padding-right: 20px;
    }
    .readiness-row .top-text {
        font-size: 18px;
        font-weight: 700;
    }
    .readiness-row .bottom-text {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
    }


</style>